import { createContext, useContext, useState, useCallback, useMemo } from "react";
import { DICT } from "../lib/i18n";

const LangCtx = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("pn28_lang") || "de");
  const setLang = useCallback((l) => { localStorage.setItem("pn28_lang", l); setLangState(l); document.documentElement.lang = l; }, []);
  const value = useMemo(() => ({
    lang,
    setLang,
    t: (key, vars) => {
      let s = DICT[lang][key] ?? key;
      if (vars && typeof s === "string") Object.entries(vars).forEach(([k, v]) => { s = s.replace(`{${k}}`, v); });
      return s;
    },
    tr: (deText, enText) => (lang === "en" ? enText : deText),
    pname: (p) => (lang === "en" ? p.name_en || p.name_de : p.name_de),
    pdesc: (p) => (lang === "en" ? p.description_en || p.description_de : p.description_de),
  }), [lang, setLang]);
  return <LangCtx.Provider value={value}>{children}</LangCtx.Provider>;
};

export const useLang = () => useContext(LangCtx);
